// src/state/todoState.js
import { atom } from "jotai";

// Átomo que almacena la lista de tareas
export const beneficiaryIdState = atom({
  key: "beneficiaryIdState", // Debe ser único
  default: -1, // Estado inicial: false
});

// // Selector para obtener la cantidad de tareas
// export const todoListCountState = selector({
//   key: "todoListCountState",
//   get: ({ get }) => {
//     const todoList = get(todoListState);
//     return todoList.length;
//   },
// });
